import { render, staticRenderFns } from "./BubblesBlock.vue?vue&type=template&id=6dc1a756"
import script from "./BubblesBlock.vue?vue&type=script&lang=js"
export * from "./BubblesBlock.vue?vue&type=script&lang=js"
import style0 from "./BubblesBlock.vue?vue&type=style&index=0&id=6dc1a756&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports